var React = require('react');

function TrackStraight (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"5","y":"4","width":"38","height":"4","fill":"#3F3F3F","key":0}),React.createElement("rect",{"x":"5","y":"16","width":"38","height":"4","fill":"#3F3F3F","key":1}),React.createElement("rect",{"x":"5","y":"28","width":"38","height":"4","fill":"#3F3F3F","key":2}),React.createElement("rect",{"x":"5","y":"40","width":"38","height":"4","fill":"#3F3F3F","key":3}),React.createElement("path",{"d":"M32 5.72205e-06H36V48H32V5.72205e-06Z","fill":"black","key":4}),React.createElement("path",{"d":"M12 7.62939e-06H16V48H12V7.62939e-06Z","fill":"black","key":5})]);
}

TrackStraight.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = TrackStraight;

TrackStraight.default = TrackStraight;
